import { render, staticRenderFns } from "./GoodsBrandDetail.vue?vue&type=template&id=3feadc04&scoped=true&"
import script from "./GoodsBrandDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsBrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feadc04",
  null
  
)

export default component.exports